module.exports = __webpack_public_path__ + "static/media/2.516cb5ae.png";